import type { TypePolicies } from '../../../utils';
import { cursorPaginationFieldPolicy } from '../../../utils/policies/cursorPaginationFieldPolicy';

export const typePolicies: TypePolicies = {
  Query: {
    fields: {
      asset: {
        /**
         * Conditionally determines which argument to use as the cache key. Once `assetId` has
         * been removed (currently deprecated) this can be cleaned up.
         */
        keyArgs(args) {
          if (args?.by) {
            return ['by'];
          }
          return ['assetId'];
        },
        merge: true,
      },
    },
  },

  Asset: {
    fields: {
      approvals: cursorPaginationFieldPolicy(['filter', 'orderBy']),
      /**
       * In a Share for review, the parent field is null unless authorized. Once authorized,
       * the parent field can be populated. This field is used to determine the path to the asset in the project.
       *
       * These merge functions ensure that the parent field remain populated once hydrated intead of being
       * nulled out by other queries that may have been executed without bypassing share auth.
       */
      parent: {
        merge: (existing, incoming, { mergeObjects }) => {
          if (existing === null && incoming) {
            return incoming;
          }

          if (incoming === null && existing) {
            return existing;
          }

          return mergeObjects(existing, incoming);
        },
      },
    },
  },
};
